import { Injectable, inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { first, switchMap } from "rxjs/operators";
import { Observable } from "rxjs";
import { TranslocoService } from "@jsverse/transloco";

@Injectable({
  providedIn: "root",
})
export class LorenSnackBarService {
  private translate = inject(TranslocoService);
  private snackBar = inject(MatSnackBar);


  showSuccessMessage() {
    this.translate
      .selectTranslate("operations.successful")
      .pipe(first())
      .subscribe((translation) => {
        this.snackBar.open(translation, null, { duration: 5000 });
      });
  }

  showErrorMessage(error: string, durationInMSec = 7000) {
    this.snackBar.open(error, null, {
      duration: durationInMSec,
      panelClass: ["mat-toolbar", "mat-warn"],
    });
  }

  showTranslatedErrorMessage(error: string, durationInMSec = 7000) {
    this.translate
      .selectTranslate(error)
      .pipe(first())
      .subscribe((translation) => {
        this.snackBar.open(translation, null, {
          duration: durationInMSec,
          panelClass: ["mat-toolbar", "mat-warn"],
        });
      });
  }

  showTranslatedSuccessMessage(message: string, durationInMSec = 5000) {
    this.translate
      .selectTranslate(message)
      .pipe(first())
      .subscribe((translation) => {
        this.snackBar.open(translation, null, { duration: durationInMSec });
      });
  }

  showNoDataAvailableForAsset() {
    this.translate
      .selectTranslate("chart.no_data_available")
      .pipe(first())
      .subscribe((translation) => {
        this.snackBar.open(translation, null, { duration: 5000 });
      });
  }

  showFileSizeExceededError(fileSizeLimitInMb: number) {
    this.translate
      .selectTranslate("errors.file_size_exceeded", {
        value: fileSizeLimitInMb,
      })
      .pipe(first())
      .subscribe((translation) => {
        this.snackBar.open(translation, null, {
          duration: 5000,
          panelClass: ["mat-toolbar", "mat-warn"],
        });
      });
  }

  showFileTypeNotAllowedError(fileName: string, allowedFileTypes: string) {
    this.translate
      .selectTranslate("errors.file_type_not_allowed", {
        value: fileName,
        values: allowedFileTypes,
      })
      .pipe(first())
      .subscribe((translation) => {
        this.snackBar.open(translation, null, {
          duration: 5000,
          panelClass: ["mat-toolbar", "mat-warn"],
        });
      });
  }

  showMessage(message: string) {
    this.snackBar.open(message, null, { duration: 10000 });
  }

  showMessageWithAction(message: string, action: string): Observable<void> {
    return this.translate.selectTranslate([message, action]).pipe(
      switchMap((translation) => {
        return this.snackBar
          .open(translation[message], translation[action], {
            panelClass: ["mat-toolbar", "mat-warn"],
          })
          .onAction();
      })
    );
  }
}
